<template lang="pug">
.row.i_mt_8(:class="{ 'flex-row-reverse': direction % 2 == 1 }")
  .col-md-6.text-center.text-md-left
    .img(:style="{ backgroundImage: 'url(' + news.Image + ')' }")
  .col-md-6(:class="{ info_left_padding: direction % 2 == 0 }")
    .info.i_mt_sm_6
      h3 {{ news.Title }}
      .date 
        | {{ news.PostDate }}
        svg-icon.i_ml_1(
          iconClass="contact",
          className="icon",
          v-if="news.isNew"
        )
      .description.i_body_l.i_mt_4.i_mt_md_2.i_mt_sm_4 {{ news.Brief }}
      router-link.see_more_btn.float-right.i_mt_2(
        tag="a",
        :to="{ name: 'Detail', query: { type: type, id: news.ID } }"
      ) 更多
</template>

<script>
export default {
  name: "NewsItem",
  props: {
    news: Object,
    direction: Number,
    type: String,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/about_us/news_item";
</style>
